import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { ImagePath, ImageRelativePath } from '../../constants';
import { CardMedia, } from '@mui/material';
import CardContainer from '../../utils/CardContainer';
import { MovingText } from '../../utils/MovingText';
import ProgressBar from '../student/ProgressBar';
import ReadMoreText from '../../utils/ReadMore';

const SchoolMyCourseCard = ({ item, details, title, buttonAction, buttonText }) => {
    return (
        <>
            <CardContainer>
                <CardMedia
                    sx={{
                        width: { lg: "35%", xs: "100%" },
                        borderRadius: "15px",
                        height: { lg: "auto", xs: "200px" }
                    }}
                    image={`${ImagePath}${ImageRelativePath}${item?.cover_image}`}
                    alt={title}
                />
                <CardContent sx={{ flex: 1, px: { lg: "15px", xs: "0" } }}>
                    <Box sx={{ display: "grid", gridTemplateColumns: "auto max-content", alignItems: "center" }}>
                        <Box sx={{ minWidth: 0 }}>
                            <MovingText text={title} variant={"h5"} />
                        </Box>

                    </Box>

                    <Box sx={{ my: 1 }}>
                        {details?.map((item, index) => (
                            <Box key={index}>

                                <Typography fontSize={"13px"} variant="body2">
                                    {item?.label} : {" "}
                                    {item?.value}
                                </Typography>


                            </Box>

                        ))}
                    </Box>
                    <ReadMoreText text={item?.description} line={1} />
                    {/* <Typography variant='body2'>{item?.description}</Typography> */}
                    <Box my={2}> <ProgressBar /></Box>


                    {
                        buttonAction &&
                        <Button variant='contained' fullWidth
                            onClick={buttonAction}
                        >
                            {buttonText ?? "View Detail"}
                        </Button>
                    }
                </CardContent>
            </CardContainer>
        </>
    );
}

export default SchoolMyCourseCard;

